<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch5">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch5.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">The red liquid gleams. A vampire places a plastic straw in one of the goblets and holds it toward you. “Sip?”</p>
<p class="para" style="text-indent: 5%;">You lick your dry lips.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">You’d die for a gulp.</em></p>
<p class="para" style="text-indent: 5%;">But you swallow hard and shake your head.</p>
<p class="para" style="text-indent: 5%;">You can’t let yourself drink it. If you do, and it’s blood — and you <em class="italic">know</em> it’s blood — you’re pretty sure you’ll be a vampire forever. And forever is a long time.</p>
<p class="para" style="text-indent: 5%;">“No,” you repeat. “I’ll pass on the blood!”</p>
<p class="para" style="text-indent: 5%;">“I’m sorry you feel that way,” Countess Yvonne says.</p>
<p class="para" style="text-indent: 5%;">She gives one short nod to the others. They glide toward you. Closing in on you.</p>
<p class="para" style="text-indent: 5%;">In desperation, you search for a weapon. But the only thing you see are the goblets of blood.</p>
<p class="para" style="text-indent: 5%;">Frantically, you dart to the table and lift a goblet. You toss the whole glassful of liquid into the countess’s face!</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Turn to <span href="#/e9780545820660_ch016" title="Link target outside of Sample">PAGE 16</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch005.vue?39f43ae1